webpackJsonp([6],{

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
/** Import frontoffice_app */

__webpack_require__(5);

var _cart = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @class ProductSingleHandler
 */
var ProductSingleHandler =
/*#__PURE__*/
function () {
  /**
   * @constructor
   */
  function ProductSingleHandler() {
    _classCallCheck(this, ProductSingleHandler);

    this._listenAlreadyInCart();

    this._listenAddToCart();
  }
  /**
   * @private
   */


  _createClass(ProductSingleHandler, [{
    key: "_listenAlreadyInCart",
    value: function _listenAlreadyInCart() {
      var itemData = $('#add_to_cart').data('cartitem').split('|'),
          slug = itemData[0],
          cart = _cart.default.getCartItems();

      $.each(cart, function (k, v) {
        if (v.slug === slug) {
          $('#quantity').val(v.quantity);
        }
      });
    }
    /**
     * @private
     */

  }, {
    key: "_listenAddToCart",
    value: function _listenAddToCart() {
      $('#add_to_cart').unbind('click').on('click', function (e) {
        e.preventDefault();
        var quantity = $('#quantity').val();

        if (parseInt(quantity) > 0) {
          var itemData = $(e.target).data('cartitem'),
              itemDataStr = itemData + '|' + quantity;

          _cart.default.addToCartFromSinglePage(itemDataStr);
        }
      });
    }
  }]);

  return ProductSingleHandler;
}();
/** Start ProductSingleHandler */


$(document).ready(function () {
  new ProductSingleHandler();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

},[273]);


// WEBPACK FOOTER //
// frontoffice_product_single.js